import { ArrowUpRight } from "lucide-react";
import { PRODUCTS } from "@/data/content";
import { useQuote } from "@/context/QuoteContext";
import { Reveal } from "@/components/site/Motion";

export default function Products() {
  const { openQuote } = useQuote();
  return (
    <section id="products" className="py-24 sm:py-32 bg-brand-cream">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl mb-14">
          <span className="overline">Lines of business</span>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-brand-ink mt-4 leading-[1.02]">
            One agency. <span className="italic text-brand-clay">Every coverage</span> you need.
          </h2>
          <p className="mt-5 text-brand-moss leading-relaxed">
            As an independent agency, we tailor each policy to your life and shop it across our carrier network for the right fit and price.
          </p>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {PRODUCTS.map((p, i) => {
            const Icon = p.icon;
            const large = i === 0 || i === 3;
            return (
              <Reveal key={p.slug} delay={i * 0.06} className={large ? "md:col-span-1" : ""}>
                <button
                  onClick={() => openQuote(p.slug)}
                  data-testid={`product-${p.slug}`}
                  className="group relative w-full text-left overflow-hidden rounded-2xl border border-brand-line bg-white h-full"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img src={p.image} alt={p.title}
                      className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                    <div className="absolute inset-0 bg-gradient-to-t from-brand-ink/60 to-transparent" />
                    <div className="absolute top-4 left-4 grid h-11 w-11 place-items-center rounded-full bg-brand-cream/90 text-brand-green">
                      <Icon className="h-5 w-5" />
                    </div>
                    <ArrowUpRight className="absolute top-5 right-5 h-6 w-6 text-brand-cream opacity-0 group-hover:opacity-100 -translate-x-1 group-hover:translate-x-0 transition-all" />
                  </div>
                  <div className="p-7">
                    <h3 className="font-serif text-3xl text-brand-ink">{p.title} Insurance</h3>
                    <p className="mt-1 text-sm text-brand-clay font-medium">{p.tagline}</p>
                    <p className="mt-3 text-brand-moss text-sm leading-relaxed">{p.desc}</p>
                    <div className="mt-5 flex flex-wrap gap-2">
                      {p.points.map((pt) => (
                        <span key={pt} className="rounded-full bg-brand-sand/40 px-3 py-1 text-xs text-brand-green">{pt}</span>
                      ))}
                    </div>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
